import { useState } from 'react';
import DashboardWrapper from '../../layout/DashboardWrapper';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '../../components/ui/collapsible';
import { Button } from '../../components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import defaultFaqs from './faqs.json';

const LOCAL_FAQ_KEY = 'zindua:faqs';

export default function FAQPage() {
    // Load from localStorage (edited by admin) or fallback to bundled JSON
    const [faqs] = useState(() => {
        try {
            const raw = localStorage.getItem(LOCAL_FAQ_KEY);
            if (raw) return JSON.parse(raw);
        } catch (e) {
            console.error(e);
            // ignore parse errors
        }
        return defaultFaqs;
    });
    const [expandedId, setExpandedId] = useState(null);

    return (
        <DashboardWrapper>
            <div className="flex flex-col gap-4 py-6">
                <div className="flex items-center gap-3">
                    <h1 className="text-2xl font-semibold">Frequently Asked Questions</h1>
                </div>

                <div className="grid grid-cols-1 gap-4">
                    {faqs.map(f => {
                        const isOpen = expandedId === f.id;
                        return (
                            <Collapsible key={f.id} open={isOpen}>
                                <CollapsibleTrigger
                                    className={`w-full border border-neutral-300 p-0.5 ${isOpen ? 'rounded-t-xl hover:rounded-t-xl' : 'rounded-xl hover:rounded-xl'}`}
                                    onClick={() => {
                                        setExpandedId(prev => (prev === f.id ? null : f.id));
                                    }}
                                >
                                    <div className="flex items-center justify-between gap-3 py-3 px-4 hover:bg-neutral-100 transition-colors">
                                        <span className="font-semibold text-neutral-900">{f.question}</span>
                                        <Button variant="ghost" className="px-2 py-1" aria-label={isOpen ? 'Collapse' : 'Expand'}>
                                            {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                                        </Button>
                                    </div>
                                </CollapsibleTrigger>
                                <CollapsibleContent>
                                    <div className="p-4 rounded-b-xl bg-neutral-50 border border-t-0 border-neutral-200">
                                        <p className="text-neutral-700">{f.answer}</p>
                                    </div>
                                </CollapsibleContent>
                            </Collapsible>
                        );
                    })}
                </div>
            </div>
        </DashboardWrapper>
    );
}
